import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import apiCalls from '../PowerShadesAPIFunctions';
import { QuoteApprovalViewModel } from '../powershadesApiTypes';

const QuoteReviewTable = ({ quoteId }: { quoteId: number }) => {
	const [reviews, setReviews] = useState<QuoteApprovalViewModel[]>([]);

	useEffect(() => {
		apiCalls.getQuoteApprovals(quoteId).then((resp) => setReviews(resp.data?.quote_reviews ?? []));
	}, [quoteId]);

	const dateConverter = (date) => {
		const formattedDate = new Date(date);
		const newDate = new Date();
		newDate.setTime(formattedDate.getTime());
		return formattedDate.toLocaleString();
	};

	return (
		<div>
			<h2 className='pb-1'>Quote Reviews</h2>
			{reviews.length === 0 ? (
				<Card className="text-center">
					<Card.Body>
						<p className="text-muted mb-0">No reviews found for this quote.</p>
					</Card.Body>
				</Card>
			) : (
				reviews.map((review) => (
					<Card key={review.quote_id} className="mb-3 shadow-sm">
						<Card.Header className="d-flex justify-content-between align-items-center">
							<h6 className="mb-0 fw-bold">
								{review.review_cause_type}
							</h6>
							<Badge bg={review.review_status === 'Success' ? 'success' : 'danger'}>
								{review.review_status || 'Pending'}
							</Badge>
						</Card.Header>
						<Card.Body>
							<Row className="g-3">
								<Col md={6}>
									<div className="mb-2">
										<small className="text-muted fw-bold">DESCRIPTION</small>
										<p className="mb-0">{review.review_cause_description || 'N/A'}</p>
									</div>
								</Col>
								<Col md={3}>
									<div className="mb-2">
										<small className="text-muted fw-bold">CREATED</small>
										<p className="mb-0">
											{review.requested_time ? dateConverter(review.requested_time) : 'N/A'}
										</p>
									</div>
								</Col>
								<Col md={3}>
									<div className="mb-2">
										<small className="text-muted fw-bold">EXECUTED</small>
										<p className="mb-0">
											{review.reviewed_time ? dateConverter(review.reviewed_time) : 'N/A'}
										</p>
									</div>
								</Col>
								<Col md={3}>
									<div className="mb-2">
										<small className="text-muted fw-bold">APPROVER</small>
										<p className="mb-0">
											{review.reviewer_name ? review.reviewer_name : 'N/A'}
										</p>
									</div>
								</Col>
								{review.rejection_notes && (
									<Col md={12}>
										<div className="alert alert-danger py-2 mb-0">
											<small className="text-danger fw-bold">ERROR DETAILS</small>
											<p className="mb-0 mt-1">{review.rejection_notes}</p>
										</div>
									</Col>
								)}
							</Row>
						</Card.Body>
					</Card>
				))
			)}
		</div>

	);
};

export default QuoteReviewTable;
